import { useEffect, useState, useRef } from 'react';

interface ScrollProgressProps {
  targetSelector?: string; // CSS selector to watch
  className?: string;
}

export function ScrollProgress({ targetSelector = '.preview-panel', className }: ScrollProgressProps) {
  const [progress, setProgress] = useState(0);
  const frameRef = useRef<number>();

  useEffect(() => {
    const el = document.querySelector<HTMLElement>(targetSelector);
    if (!el) return;
    const onScroll = () => {
      if (frameRef.current) cancelAnimationFrame(frameRef.current);
      frameRef.current = requestAnimationFrame(() => {
        const scrollTop = el.scrollTop;
        const max = el.scrollHeight - el.clientHeight;
        setProgress(max > 0 ? Math.min(100, (scrollTop / max) * 100) : 0);
      });
    };
    el.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => {
      el.removeEventListener('scroll', onScroll);
      if (frameRef.current) cancelAnimationFrame(frameRef.current);
    };
  }, [targetSelector]);

  return (
    <div
      className={`absolute top-0 left-0 right-0 h-0.5 bg-white/5 z-10 pointer-events-none ${className ?? ''}`}
      aria-hidden="true"
    >
      <div
        className="h-full bg-gradient-to-r from-violet-500 to-fuchsia-500 transition-[width] duration-100"
        style={{ width: `${progress}%` }}
      />
    </div>
  );
}
